export default "__VITE_ASSET__BOuLU2gx__"